export const detail = {
    routeTitle: 'Zoznam užívateľov vo vybranej lokalite',
    listOfUsers: 'Zoznam užívateľov',
    homeDetail: 'Detail',
    metersLabel: 'Watt-metre',
    usersLabel: 'Užívatelia lokality',
    siteConfig: 'Konfigurácia lokality',
    noUsersLabel: 'Žiadni užívatelia pre zvolenú lokalitu',
    detailRouteTitle: 'Detail lokality',
    detailRoute: 'Detail',
    detailInformationTitle: 'Informácie o lokalite',
    deleteConfirmTitle: 'Ste si istý že chcete vymazať túto lokalitu?',
    deleteConfirmDescription: ['Lokalita s menom', 'bude trvalo vymazaná.'],
    // Meters
    addMeterButton: 'Pridať nový watt-meter',
    addMeterModalTitle: 'Pridať nový watt-meter',
    deleteDeviceModalTitle: 'Naozaj chcete vymazať toto zariadenie?',
    canNotFetchDevicesForDeletedMeter: 'Nie je možné načítať zariadenia na vymazanom watt-metri.',
    undeleteDeviceOrMeter: 'sa po akcii obnoví.',
    deleteDeviceConfirmDescription: ['Zariadenie na watt-metri s menom', 'bude po akcii vymazané.'],
    deleteMeterModalTitle: 'Naozaj chcete vymazať tento watt-meter?',
    deleteMeterConfirmDescription: ['Watt-meter s menom', 'bude po akcii vymazaný.'],
    addDeviceButton: 'Pridať zariadenie',
    addDeviceModalTitle: 'Pridať nové zariadenie pre watt-meter',
    editDeviceModalTitle: 'Úprava zariadenia pre watt-meter',
    editDeviceButton: 'Upraviť zariadenie',
    editMeterModalTitle: 'Úprava watt-metra',
    meterName: 'Názov watt-metra',
    meterMacAddress: 'MAC adresa watt-metra',
    meterMacAddressFormatField:
        'Formát MAC adresy je nesprávny. Povolené znaky sú: a-f A-F a 0-9. Povolená dĺžka je 12 znakov.',
    meterIpAddress: 'IP adresa',
    meterUrl: 'URL',
    enphaseUser: 'Enphase User',
    enphaseSerial: 'Enphase Serial',
    meterReadingsPerMinute: 'Počet odoslaných údajov za 1 minútu',
    meterType: 'Typ watt-metra',
    noDevicesOnMonitor: 'Neboli pridané žiadne zariadenia na watt-metri.',
    deviceName: 'Názov zariadenia',
    deviceQuality: 'Kvalita natrénovania',
    deviceType: 'Typ zariadenia',
    deviceCountLabel: 'Počet rovnakých výskytov',
    subscriptionType: 'Predplatená služba',
    subscriptionUntil: 'Predplatné do',
    partner: 'Partnera',
    purpose: 'Účel',
    flavor: 'Modbus Varianta',
    modbusId: 'Modbus Id',
    hub: 'Ovládač',
    production: 'Výroba',
    grid: 'Mriežka',
    usage: 'Použitie',
    storage: 'Skladovanie',
    hubDetails: 'Podrobnosti o ovládači',
    deleteMessages: 'Odstrániť správy',
    status: 'Postavenie',
    age: 'Vek',
    message: 'Správa',
    switchStatus: 'Stav',
    meterStatus: 'Stav',
    noController: '-- žiadny --',
    activateSupport: 'Aktivácia online podpory',
    deactivateSupport: 'Deaktivácia online podpory',
    onlineSupportLabel: 'Online Support',
    onlineSupportUnknown: 'Neznámy',
    onlineSupportActive: 'Aktívny',
    onlineSupportNotActive: 'Neaktívny',
    errorAlertTitle: 'Upozornenie',
    errorAlertMessage: 'Toto zariadenie je pripojené k prepínaču. Pred vymazaním zariadenia odstráňte prepínač alebo odstráňte zariadenie.',
    triggerUpdateWaPi: 'Aktualizovať WA-PI',
    triggerUpdateWaSem: 'Update WA-SEM',
    triggerUpdateMeterSupport: 'Aktualizovať Meter Support',
    triggerUpdateEvcc: 'Aktualizovať Evcc',
    triggerReadCompleteConfig: 'Prečítať kompletnú konfiguráciu',
    triggerReboot: 'Reštartovať',
    triggerRestartWaPi: 'Reštartujte Wa-Pi',
    triggerRestartWaSem: 'Reštartujte Wa-Sem',
    triggerRestartWaMeterSupport: 'Reštartujte podporu Wa-Meter-Support',
    triggerInstallLogConfigs: 'Install log-configs',
    triggerInstallLog2Ram: 'Install log2ram',
    mergeModalTitle1: 'Zlúčiť "',
    mergeModalTitle2: '" do:',
    mergeModalOk: 'Zlúčenie',

    // Users
    invitedUsers: 'Pozvaní užívatelia',
    owner: 'Vlastník',
    userName: 'Meno',
    userSurname: 'Priezvisko',
    userEmail: 'Emailová adresa',
    addUser: 'Pridať nového užívateľa',
    sureToDeleteContent: 'Email užívateľa pozvánky na vymazanie: ',
    sureToDeleteHelp: 'Potvrďte meno užívateľa ktorého chcete vymazať',

    modbusStateFunctionCode: "Modbus funkčný kód pre stav",
    modbusStateRegisterStartAddress: "Začiatočná adresa registra Modbus pre štát",
    modbusStateRegisterQuantity: "Modbus register-množstvo pre stav",
    modbusStateMinValue: "Minimálna hodnota Modbus pre štát",
    modbusStateMaxValue: "Maximálna hodnota Modbus pre štát",
    modbusStateDataType: "Dátový typ Modbus pre stav",
    modbusStateFactor: "Faktor Modbus (minimálne a maximálne hodnoty sa vynásobia) pre stav",

    modbusWattFunctionCode: "Funkčný kód Modbus na čítanie wattových hodnôt",
    modbusWattRegisterStartAddress: "Štartovacia adresa registra Modbus na čítanie hodnôt wattov",
    modbusWattRegisterQuantity: "Modbus register-quantity pre čítanie wattových hodnôt",
    modbusWattDataType: "Dátový typ Modbus na čítanie wattových hodnôt",
    modbusWattFactor: "Faktor Modbus pre načítané wattové hodnoty",

    modbusTempFunctionCode: "Funkčný kód Modbus na čítanie hodnôt teploty",
    modbusTempRegisterStartAddress: "Štartovacia adresa registra Modbus na čítanie hodnôt teploty",
    modbusTempRegisterQuantity: "Modbus register-množstvo na čítanie hodnôt teploty",
    modbusTempDataType: "Dátový typ Modbus na čítanie hodnôt teploty",
    modbusTempFactor: "Modbus faktor na čítanie hodnôt teploty",
    meterA: "Mierka A",
    meterB: "Mierka B",
    meterSoc: "Merací prístroj pre SoC",
    solaxRegistrationNr: "Registration number",
    neoomBeaamApiKey: 'Key for BEAAM API',
};
